import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

export const BulkUploaderWrapper = styled.div`
  width: 100%;
`;

export const DragAndDropArea = styled.div<{ disabled?: boolean; hasError?: boolean; useTheme?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border-radius: ${theme.borderRadius['border-radius-3']};
  border: dashed 2px
    ${({ hasError, useTheme }) =>
      hasError
        ? theme.colors.danger.border.regular
        : useTheme ? theme.colors.primary.border.regular : theme.colors.success.border.regular};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing['spacing-4']};
  min-height: 200px;
  background-color: ${({ disabled }) =>
    disabled ? theme.colors.neutral.bg.regular : 'transparent'};
  transition: all 0.2s ease;

  &:hover {
    ${({ disabled, useTheme }) =>
      !disabled &&
      css`
        border-color: ${useTheme ? theme.colors.primary.border.strong : theme.colors.success.border.strong};
        background-color: ${useTheme ? theme.colors.primary.bg.weak : theme.colors.success.bg.weak};
      `}
  }
`;

export const DropBaseIcon = styled.div<{ useTheme?: boolean }>`
  border-radius: 100px;
  background-color: ${({ useTheme }) => useTheme ? theme.colors.primary.bg.weak : theme.colors.success.bg.weak};
  padding: 10px;
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${theme.spacing['spacing-2']};
`;

export const DropBaseIconWrapper = styled.div<{ useTheme?: boolean }>`
  border-radius: 100px;
  background-color: ${({ useTheme }) => useTheme ? theme.colors.primary.border.regular : theme.colors.success.border.weak};
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MainTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['spacing-2']};
  align-items: center;
  text-align: center;
`;

export const FileInput = styled.input`
  display: none;
`;

export const GlobalError = styled.div`
  margin-top: ${theme.spacing['spacing-2']};
  padding: ${theme.spacing['spacing-2']};
  background-color: ${theme.colors.danger.bg.weak};
  border: 1px solid ${theme.colors.danger.border.regular};
  border-radius: ${theme.borderRadius['border-radius-3']};
  color: ${theme.colors.danger.text.strong};
  font-size: 18px;
  line-height: 28px;
`;

export const FileRowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing['spacing-4']};
  width: 100%;
  box-sizing: border-box;
  
  > svg,
  > *:first-child {
    flex-shrink: 0;
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: ${theme.spacing['spacing-2']};
    
    > svg,
    > *:first-child {
      align-self: flex-start;
    }
  }
`;

export const DropdownWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  height: 46px;
  box-sizing: border-box;
  
  > div {
    width: 100%;
    min-width: 0;
    height: 100%;
    align-items: center;
    
    button {
      height: 46px;
      min-height: 46px;
    }
  }
  
  @media (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    min-width: 200px;
  }
`;

export const FileNameWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  height: 46px;
  box-sizing: border-box;
  margin-top: 15px;

  @media (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    min-width: 200px;
  }
`;

